// @ts-check

// 賞品の獲得予定ポイントを表示するコンポーネント
class ProductPoint extends HTMLElement {
  // 変更を監視するattributeを指定
  static get observedAttributes() {
    return ["variant-id"];
  }

  constructor() {
    super();

    this.attachShadow({ mode: "open" });

    this.loading = false;
    this.point = 0;
  }

  // attributeが変更されたときに呼ばれる
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "variant-id" && newValue && oldValue !== newValue) {
      this.updatePoint(newValue);
    }
  }

  async updatePoint(variantIds = '') {
    this.loading = true;
    this.render();

    try {
      const pointData = await this.fetchPointData(variantIds);

      this.point = pointData.grantingPoints;
    } catch (e) {
      console.error(e);
    } finally {
      this.loading = false;
      this.render();
    }
  }

  fetchPointData(variantIds) {
    let backendBaseUri = "/apps/grapht-custom-app-proxy/api/v1/shopifyApp/";

    // 開発環境の場合
    if (location.hostname === 'dev-grapht-store.myshopify.com') {
        backendBaseUri = "/apps/grapht-custom-app-dev-proxy/api/v1/shopifyApp/";
    }
    
    const url = `${backendBaseUri}getGrantingPoints`;

    // cart向けのapiを叩いてポイント情報を取得するので形式を合わせる
    const cartData = { items: [], currency: "JPY" };
    variantIds.split(',').forEach((variantId) => {
      cartData.items.push({ quantity: 1, variant_id: variantId });
    })

    return fetch(url, {
      method: "POST",
      body: JSON.stringify({ context: "cart", cartData }),
      headers: {
        "Content-Type": "application/json",
      },
    }).then((r) => r.json());
  }

  render() {
    if (!this.shadowRoot) {
      return;
    }

    const text = this.loading
      ? "-"
      : `${this.point.toLocaleString()}`;

    this.shadowRoot.innerHTML = `
      <style>
        :host {
          height: 30px;
        }

        .point {
          font-size: 1.2rem;
          font-weight: bold;
        }
      </style>

      獲得予定ポイント: <span class="point">${text} PT</span>
    `;
  }
}

customElements.define("product-point", ProductPoint);
